export  enum Constantes {
    AND = " AND ",
    OR = " OR ",
    NOT = " NOT ",
    DDMMYYYY = "DD/MM/YYYY",
    YYYYMMDD = "YYYY/MM/DD",
    PARENTESE = "(",
    CODIGONORMA = 'codigoNorma:',
    NUMERONORMA = 'numeroNorma:',
    ANODOCUMENTO = 'anoDocumento:'
}
export default Constantes;

